module.exports = __webpack_public_path__ + "static/media/leaderboard-img8.59bae228.jpeg";